import { render, staticRenderFns } from "./InvitationStatistics.vue?vue&type=template&id=3cb2a457&"
import script from "./InvitationStatistics.vue?vue&type=script&lang=js&"
export * from "./InvitationStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports